export default __webpack_public_path__ + "static/media/common_detail.126a6e6a.png";